import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import sweetAlert from 'sweetalert'

const initialState = {
    view_option: "LIST",
    mcq: {
        question: "",
        correct: "",
        option1: "",
        option2: "",
        option3: "",
        moduleId: 1
    },
    edit_mcq: {},
}
export default class Mcqlist extends Component {

    constructor(props) {
        super(props)
        this.state = {
            view_option: "LIST",     //EDIT, DELETE, CREATE
            mcq: {
                question: "",
                correct: "",
                option1: "",
                option2: "",
                option3: "",
                moduleId: 1
            },
            edit_mcq: {},
            courseId: "",
            all_data: [],
            isDataLoded: false,
            totalModulesNo: 0,
            moduleList: []


        }
    }
    componentDidMount() {
        const thePath = window.location.href;
        const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
        this.setState({ courseId: lastItem }, () => {
            this.getAllData();
            this.productData();
        })
    }
    productData = () => {
        fetch(`${process.env['REACT_APP_HOST']}/api/products/${this.state.courseId}`)
            .then((response) => response.json())
            .then(result => {
                let obj = []
                for (let i = 1; i <= Number(result.modulesNo); i++) {
                    obj.push(i)
                }
                this.setState({ totalModulesNo: result.modulesNo, moduleList: obj })

            });
    }
    editClick = (list) => {
        this.setState({ edit_mcq: list, view_option: "EDIT" })
    }
    createClick = () => {
        this.setState({ view_option: "CREATE" })
    }
    listClick = () => {
        this.setState(initialState)
    }
    inputHandler = (e) => {
        let mcq = {
            ...this.state.mcq,
            [e.target.name]: e.target.name == "moduleId" ? Number(e.target.value) : e.target.value
        }
        this.setState({ mcq: mcq })
    }
    inputHandlerEdit = (e) => {
        let edit_mcq = {
            ...this.state.edit_mcq,
            [e.target.name]: e.target.name == "moduleId" ? Number(e.target.value) : e.target.value
        }
        this.setState({ edit_mcq: edit_mcq })
    }
    createMcq = () => {
        if (this.state.mcq.question == "" || this.state.mcq.correct == "" || this.state.mcq.option1 == "") {
            toast.error("Please fill all requied field.")
            return
        }
        const url = `${process.env['REACT_APP_HOST']}/api/mcqmaster/create_mcq/`;
        const params = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                courseId: this.state.courseId,
                ...this.state.mcq

            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                console.log("data");
                console.log(data);
                if (data.error == false) {
                    toast.success("Successfully Created !")
                    this.setState(initialState)
                    this.getAllData()
                    // window.location.reload();
                    return
                }
                toast.error("Please Retry.")
            })
    }

    getAllData = () => {
        const url = `${process.env['REACT_APP_HOST']}/api/mcqmaster/fetch_all/`;
        const params = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                courseId: this.state.courseId,
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                if (data.error == false) {
                    this.setState({ all_data: data.mcq_data, isDataLoded: true })
                }

            })
    }
    editMcq = () => {
        if (this.state.edit_mcq.question == "" || this.state.edit_mcq.correct == "" || this.state.edit_mcq.option1 == "") {
            toast.error("Please fill all requied field.")
            return
        }
        const url = `${process.env['REACT_APP_HOST']}/api/mcqmaster/edit/`;
        const params = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...this.state.edit_mcq
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                if (data.error == false) {
                    toast.success("Successfully Updated !")
                    this.setState(initialState)
                    this.getAllData()
                    return
                }
                toast.error("Please Retry.")
            })
    }
    deleteMcq = (_id) => {
        sweetAlert({ title: "Are you sure you wish to delete this item?", icon: "warning", dangerMode: true, buttons: true })
            .then((value) => {
                if (value) {
                    this.startDeleteProcess(_id);
                }
            })

    }
    startDeleteProcess = (_id) => {
        const url = `${process.env['REACT_APP_HOST']}/api/mcqmaster/delete/`;
        const params = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                _id: _id
            }),
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
                if (data.error == false) {
                    toast.success("Successfully Deleted !")
                    this.setState(initialState)
                    this.getAllData()
                    return
                }
                toast.error("Please Retry.")
            })
    }
    render() {
        console.log(this.state);

        return (
            <Fragment>
                <Breadcrumb title={`${this.state.view_option} MCQ`} parent="MCQ" />
                <ToastContainer />

                <br />
                {this.state.view_option == "LIST" ?
                    <div className="container-fluid">
                        <div className="form-group mb-0">
                            {this.state.isDataLoded ?
                                <div className="product-buttons">
                                    <input onClick={this.createClick} value="Create" type="button" className="btn btn-primary " />
                                </div>
                                : null}
                        </div>
                        <div className="row product-adding">
                            <div className="col-xl-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div>
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">S.No</th>
                                                        <th scope="col">Question</th>
                                                        <th scope="col">Correct Option</th>
                                                        <th scope="col">Option 1</th>
                                                        <th scope="col">Option 2</th>
                                                        <th scope="col">Option 3</th>
                                                        <th scope="col">Module No</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                {this.state.all_data.map((list, index) =>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">{index + 1}</th>
                                                            <td>{list.question} </td>
                                                            <td>{list.correct}</td>
                                                            <td>{list.option1}</td>
                                                            <td>{list.option2}</td>
                                                            <td>{list.option3}</td>
                                                            <td style={{textAlign:'center'}}>{list.moduleId}</td>
                                                            <td style={{display:"flex",}}>
                                                                <div onClick={() => this.editClick(list)}>
                                                                    <i className="fa fa-pencil" style={{ width: 35, fontSize: 20, padding: 11, color: 'rgb(40, 167, 69)', cursor:'pointer' }}></i>
                                                                </div>
                                                                <div onClick={() => this.deleteMcq(list._id)}>
                                                                    <i className="fa fa-trash" style={{ width: 35, fontSize: 20, padding: 11, color: '#e4566e', cursor:'pointer' }} ></i>
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}

                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    this.state.view_option == "EDIT" ?
                        <div className="container-fluid">
                            <div className="row product-adding">
                                <div className="col-xl-6">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="digital-add needs-validation">
                                                <div className="form-group">

                                                    <label for="moduleNo" className="col-form-label pt-0"><span>*</span> Select Module</label>
                                                    <select className="form-control " name="moduleId" id="moduleNo" onChange={this.inputHandlerEdit}>
                                                        {this.state.moduleList.map((list, index) =>
                                                            <option selected={this.state.edit_mcq.moduleId == list} value={list}>{list}</option>
                                                        )}
                                                    </select>
                                                </div>

                                                <div className="form-group">
                                                    <label className="col-form-label pt-0"><span>*</span> Question</label>
                                                    <input type="text" name="question" value={this.state.edit_mcq.question} onChange={this.inputHandlerEdit} className="form-control" required="required" ></input>
                                                    <input type="hidden" name="parentId" value="0" />
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label pt-0"><span>*</span> Correct Option </label>
                                                    <input className="form-control" value={this.state.edit_mcq.correct} name="correct" onChange={this.inputHandlerEdit} id="validationCustom02"  ></input>
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label pt-0"><span>*</span> Option 1</label>
                                                    <input className="form-control" value={this.state.edit_mcq.option1} name="option1" onChange={this.inputHandlerEdit} id="validationCustom02"  ></input>
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label pt-0"> Option 2</label>
                                                    <input className="form-control" value={this.state.edit_mcq.option2} name="option2" onChange={this.inputHandlerEdit} id="validationCustom02"  ></input>
                                                </div>
                                                <div className="form-group">
                                                    <label className="col-form-label pt-0"> Option 3</label>
                                                    <input className="form-control" value={this.state.edit_mcq.option3} name="option3" onChange={this.inputHandlerEdit} id="validationCustom02" ></input>
                                                </div>
                                                <br></br>
                                                <div className="form-group mb-0 d-flex">
                                                    <div className="product-buttons text-center mr-3">
                                                        <input onClick={this.listClick} value="Back" type="button" className="btn btn-primary" />
                                                    </div>
                                                    <div className="product-buttons text-center">
                                                        <input onClick={this.editMcq} value="Edit" className="btn btn-primary" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        :
                        this.state.view_option == "CREATE" ?
                            <div className="container-fluid">
                                <div className="row product-adding">
                                    <div className="col-xl-6">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="digital-add needs-validation">
                                                    <div className="form-group">

                                                        <label for="moduleNo" className="col-form-label pt-0"><span>*</span> Select Module</label>
                                                        <select className="form-control " name="moduleId" id="moduleNo" onChange={this.inputHandler}>
                                                            {this.state.moduleList.map((list, index) =>
                                                                <option selected={this.state.mcq.moduleId == list} value={list}>{list}</option>
                                                            )}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-form-label pt-0"><span>*</span> Question</label>
                                                        <input type="text" name="question" onChange={this.inputHandler} className="form-control" required="required" ></input>
                                                        <input type="hidden" name="parentId" value="0" />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-form-label pt-0"><span>*</span> Correct Option </label>
                                                        <input className="form-control" name="correct" onChange={this.inputHandler} id="validationCustom02"  ></input>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-form-label pt-0"><span>*</span> Option 1</label>
                                                        <input className="form-control" name="option1" onChange={this.inputHandler} id="validationCustom02"  ></input>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-form-label pt-0"> Option 2</label>
                                                        <input className="form-control" name="option2" onChange={this.inputHandler} id="validationCustom02"  ></input>
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-form-label pt-0"> Option 3</label>
                                                        <input className="form-control" name="option3" onChange={this.inputHandler} id="validationCustom02" ></input>
                                                    </div>
                                                    <br></br>
                                                    <div className="form-group mb-0 d-flex">
                                                        <div className="product-buttons text-center mr-3">
                                                            <input onClick={this.listClick} value="Back" type="button" className="btn btn-primary" />
                                                        </div>
                                                        <div className="product-buttons text-right">
                                                            <input onClick={this.createMcq} value="Create" type="button" className="btn btn-primary" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            :
                            null
                }
            </Fragment>
        )
    }
}
